import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/index.vue'
import Home from './views/Home.vue'
import store from './store'

// import swiper from './components/swiper'
// import AboutUs from './views/AboutUs.vue'
// console.log('recruit host ==========>', process.env.VUE_APP_RECRUIT)

// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router)

// lazy-loaded
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    // {
    // 	path: '/',
    // 	name: 'subscribe',
    // 	component: loadView('subscribe')
    // },

    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: '/faq',
          name: 'faq',
          component: loadView('faq'),
        },
        {
          path: '/fankit',
          name: 'fankit',
          component: loadView('fankit'),
        },
        {
          path: 'fankit/precautions',
          name: 'Precautions',
          component: loadView('fankit/Precautions'),
        },
        {
          path: 'fankit/guidelines',
          name: 'Guidelines',
          component: loadView('fankit/Guidelines'),
        },
        {
          path: '/news',
          name: 'news',
          component: loadView('news'),
        },
        {
          path: '/news/newsJump',
          name: 'newsJump',
          component: loadView('newsJump'),
        },
        {
          path: '/news/newsJump/:id',
          name: 'newsContext',
          component: loadView('newsJump_context'),
        },
        {
          path: '/newsjumps/:id',
          name: 'newsjumps',
          component: loadView('newsjumps'),
        },
        {
          path: '/character',
          name: 'character',
          component: loadView('character'),
        },
        {
          path: '/system',
          name: 'system',
          component: loadView('system'),
        },
        {
          path: '/contact-1-hint',
          name: 'contact-1-hint',
          component: loadView('contact'),
        },
        {
          path: '/contact/1',
          name: 'contact1',
          component: loadView('contact_1'),
        },
        {
          path: '/contact/2',
          name: 'contact2',
          component: loadView('contact_2'),
        },
        {
          path: '/contact/3',
          name: 'contact3',
          component: loadView('contact_3'),
        },
        {
          path: '/contact/4',
          name: 'contact4',
          component: loadView('contact_4'),
        },
        {
          path: '/comics',
          name: 'comics',
          component: loadView('comics'),
        },
        {
          path: '/comics02',
          name: 'comics02',
          component: loadView('comics02'),
        },
        {
          path: '/comics/:chapters/:type',
          name: 'comicsID',
          component: loadView('comics'),
        },
        {
          path: '/comics02/:chapters/:type',
          name: 'comicsID',
          component: loadView('comics02'),
        },
        {
          path: '/bosyuu',
          name: 'bosyuu',
          component: loadView('bosyuu'),
          meta: {
            title: 'ブルアカファンアート募集',
          },
        },

        {
          path: '/serial_code',
          name: 'serial_code',
          component: loadView('serial_code'),
          meta: {
            title: 'ブルアカファンアート募集',
          },
        },

      ],
    },
    {
      path: '/terms',
      name: 'terms_of_service',
      component: loadView('Terms_of_service'),
    },
    {
      path: '/privacy',
      name: 'privacy_policy',
      component: loadView('Privacy_policy'),
    },
    {
      path: '/specific_business',
      name: 'specific_business',
      component: loadView('Specific_business'),
    },
    {
      path: '/preregistration',
      name: 'subscribe',
      component: loadView('subscribe'),
    },
    {
      path: '/based',
      name: 'based',
      component: loadView('based_fund_settlement_law'),
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  // if(to.name=='comics') {
  // 	store.commit("SET_comicsState", true);
  // } else {
  // 	store.commit("SET_comicsState", false);
  // }
  if (to.fullPath === '/bosyuu') {
    window.document.title = to.meta.title
  }
  next()
})

export default router
